import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { AddressSuggestion } from "../../api/addressApi";

interface AddressMemoryState {
  items: AddressSuggestion[];
}

const initialState: AddressMemoryState = {
  items: [],
};

const addressMemorySlice = createSlice({
  name: "addressMemory",
  initialState,
  reducers: {
    addAddressMemoryItem(state, action: PayloadAction<AddressSuggestion>) {
      const exists = state.items.some((item) => item.label === action.payload.label);
      if (!exists) {
        state.items.unshift(action.payload);
      }
    },
    resetAddressMemory(state) {
      state.items = [];
    },
  },
});

export const { addAddressMemoryItem, resetAddressMemory } = addressMemorySlice.actions;
export default addressMemorySlice.reducer;
